import initialState from 'redux/initialState';
import actionTypes from 'redux/actions/actionTypes';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

import { TradingOffer } from '../../../types/TradingOffer';

type TradingOfferAction = {
  type: string;
  tradingOffers?: TradingOffer[];
  tradingOffer?: TradingOffer;
  tradingOfferId?: string;
};

const resetStateSociety = () => initialState.tradingOffers;

const getTradingOffers = (action: TradingOfferAction) => action.tradingOffers;

const createTradingOffer = (
  tradingOffers: TradingOffer[],
  action: TradingOfferAction
) => [action.tradingOffer, ...tradingOffers];

const updateTradingOffer = (
  tradingOffers: TradingOffer[],
  action: TradingOfferAction
) =>
  tradingOffers?.map((tradingOffer: TradingOffer) =>
    tradingOffer._id === action?.tradingOffer?._id
      ? action.tradingOffer
      : tradingOffer
  );

const deleteTradingOffer = (
  tradingOffers: TradingOffer[],
  action: TradingOfferAction
) =>
  tradingOffers?.filter(
    (tradingOffer: TradingOffer) => tradingOffer._id !== action.tradingOfferId
  );

export default function reducer(
  tradingOffers = initialState.tradingOffers,
  action: TradingOfferAction
) {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return resetStateSociety();

    case actionTypes.GET_TRADING_OFFERS:
      return getTradingOffers(action);

    case actionTypes.CREATE_TRADING_OFFER:
      return createTradingOffer(tradingOffers, action);

    case actionTypes.UPDATE_TRADING_OFFER:
      return updateTradingOffer(tradingOffers, action);

    case actionTypes.DELETE_OPERATION:
      return deleteTradingOffer(tradingOffers, action);

    default:
      return tradingOffers;
  }
}
